import { Button, styled } from '@mui/material';

const RightButton = styled(Button)`
  display: flex;
  align-self: end;
  margin: 12px;
`;

export default RightButton;
